import AntdLayout from 'antd/es/layout';
import styled from 'styled-components';
import { FontFamilies, LineHeights, Screens } from 'core/CssVariables';

const { Header: AntdHeader } = AntdLayout;

/* ZEST-757 dashbar: a flat bar sitting on its own surface, one rule separating
   it from the content below. The old rounded-corner shell (and the 16px inset
   that went with it) belonged to the retired purple chrome. */
const SHeader = styled(AntdHeader)`
  & {
    margin-left: 0;
    height: fit-content;
    border-radius: 0;
    background-color: ${props => props.theme.dashbar.backgroundColor};
    border-bottom: 1px solid ${props => props.theme.dashbar.borderColor};
    color: ${props => props.theme.dashbar.valueColor};
    padding: 12px 24px;
    line-height: ${LineHeights.ExtraShort};
    user-select: none;
    font-family: ${FontFamilies.FontShell};

    .header-expand-icon {
      transform: rotate(90deg);
    }

    /* Time tracker reads as one bordered control rather than a timer plus
       free-floating circular buttons. */
    #dashbar_time_tracker > .ant-row {
      flex-wrap: nowrap;
      align-items: center;
      margin: 0 !important;
      padding: 2px 6px 2px 12px;
      border: 1px solid ${props => props.theme.dashbar.borderColor};
      border-radius: 12px;

      button {
        background-color: transparent;
        border-color: transparent;
        box-shadow: none;

        /* Stroked artwork draws in currentColor, so it follows this rather than
           the button's white. */
        color: ${props => props.theme.dashbar.iconColor};

        svg:not(.stroke-icon),
        svg:not(.stroke-icon) path {
          /* The icon paints its own white fill for the old solid button, so the
             path has to be recoloured too, not just the svg. Stroked icons are
             excluded: a fill would flood the shape their outline describes. */
          fill: ${props => props.theme.dashbar.iconColor};
        }

        &:hover,
        &:focus {
          background-color: transparent;
          border-color: transparent;
        }
      }
    }

    /* The dashbar avatar follows the shell palette; avatars elsewhere in the
       app keep the primary colour. */
    #dashbar_profile .ant-avatar {
      background-color: ${props => props.theme.dashbar.avatarColor};
      border-color: transparent;
    }
  }

  /* Shave the header on small laptops so the gauges row wraps less
     aggressively and the trial-alert + create button stay
     comfortably in the first row. */
  @media (max-width: ${Screens.ScreensLaptopSm}) {
    padding: 10px 16px;
  }

  @media (max-width: ${Screens.ScreensMD}) {
    padding: 10px 12px;
  }
`;

export default SHeader;
